module.exports = __webpack_public_path__ + "img/bakingIngredient12.d049b0cc.jpeg";